module.exports = __webpack_public_path__ + "img/toy-pink@2x.ad588723.png";